import React from "react"
import {selectUnit} from "@formatjs/intl-utils"
import {FormattedRelativeTime, FormattedDate, FormattedTime, FormattedNumber, FormattedPlural} from "react-intl"
import {FormattedMessage} from "./FormattedMessage"
import FormattedCurrency from "./common/FormattedCurrency"
import getSupportedLocale from "./helpers/getSupportedLocale"
import supportedLocal from "./helpers/supported.json"
import getResolvedMessage from "./helpers/getResolvedMessage"
import getMessage from "./helpers/getMessage"

export {LangLoader} from "./Loader"
export {useIntl} from "./intlHook"
export {injectIntl} from "./injectIntl"
export type {InjectIntl} from "./injectIntl"
export type {FormatMessage} from "./types"

export const FormattedRelative = React.memo(function FormattedRelativeTimeWrapped({value}: {value?: string}) {
  if (!value) return null
  const valueMillis = Number(new Date(value))
  const diff = valueMillis - Date.now()
  const {value: v, unit} = selectUnit(Date.now() + diff)
  return <FormattedRelativeTime value={v} unit={unit} />
})

/** @see [format.js Components](https://formatjs.github.io/docs/react-intl/components) */
export {
  FormattedCurrency,
  FormattedDate,
  FormattedMessage,
  FormattedNumber,
  FormattedPlural,
  FormattedTime,
  getMessage,
  getResolvedMessage,
  getSupportedLocale,
  supportedLocal
}

export default FormattedMessage
